export * from './client';
export * from './hooks';
export * from './events';
export * from './mutations';
export * from './queries';
export * from './types';
export * from './DataProvider';
export * from './withDataProvider';

// export everything explicitly instead of export *
export {
	gql,
	makeVar,
	useApolloClient,
	useLazyQuery,
	useMutation,
	useQuery,
	useReactiveVar,
	useSubscription,
} from '@apollo/client';

export type {
	ApolloCache,
	ApolloError,
	GraphQLRequest,
	MutationFunctionOptions,
	MutationUpdaterFn,
	OperationVariables,
	QueryHookOptions,
	ReactiveVar,
	InternalRefetchQueriesInclude,
} from '@apollo/client';

export type { ExecutionResult } from 'graphql';
